<template>
<div id="email-body" class="email contatto">
   <a :href="evento.website" style="margin:10px 0 0 0;"><img :src="'https://esphm.mzevents.it/images/'+evento.id+'/head.png'" style="width:380px;border:none;" /></a>  
   <br /><br />

           
   Dear {{contatto.nome }} {{contatto.cognome }}
   <br /><br />
   Your abstract has been processed! 
   
   <br /><br />
   <div class="row pad yo-text-n" style="">
      <div class="col s7 m3 yo-align-right">IDENTIFICATION NUMBER</div>
      <div class="col s5 m9 yo-text-bold">{{abstract.id}}</div>

      <div class="col s7 m3 yo-align-right">TITLE</div>
      <div class="col s5 m9 yo-text-bold">{{abstract.titolo}} </div>

      <div class="col s7 m3 yo-align-right">LAST MODIFICATION DATE</div>
      <div class="col s5 m9 yo-text-bold">{{abstract.modificatoil | data('DD MMM YYYY')}} </div>

      <div class="col s7 m3 yo-align-right">TOPIC</div>
      <div class="col s5 m9 yo-text-bold">{{abstract.topic | items($evento._topic,'nome')}}</div>

      <div class="col s7 m3 clear yo-align-right">ORAL PRESENTATION</div>
      <div class="col s5 m9 yo-text-bold">{{abstract.oral | yesno}}</div>

      <div class="col s7 m3 clear yo-align-right">BEST POSTER AWARD</div>
      <div class="col s5 m9 yo-text-bold">{{abstract.bestposterawards | yesno}}</div>

      <div class="col s7 m3 clear yo-align-right">FLASH POSTER PRESENTATION</div>
      <div class="col s5 m9 yo-text-bold">{{abstract.flashposterpresentation | yesno}}</div>

      <div class="col s7 m3 yo-align-right">KEYWORDS</div>
      <div class="col s5 m9 yo-text-bold">{{abstract.parolechiave}}</div>

      <div class="col s7 m3 yo-align-right">PREVIEW</div>
      <div class="col s5 m9 yo-text-bold"><a :href="abstract.preview">Download PDF</a></div>

   </div>
   <br /><br />

          
               
   If you need to make changes to this abstract, please <a :href="'https://esphm.mzevents.it/abstract-submit-2025/login/'+evento.id">click here</a>  and login to abstract management system.
   <br /><br />
   If you want to send another abstract please make a new submission. 
   <br /><br /><br /><br />
   Thank you for your cooperation. 
   <br />
   The Organizing Secretariat 
   <br /><br />
   <hr />
   <div class="yo-text-s yo-color-primary">
   VET INTERNATIONAL SRL
   <br />
   <a href="mailto:abstracts@esphm2025.org.com" class="yo-color-primary">abstracts@esphm2025.org</a> | tel. +39.02.66802323 | fax +39.02.6686699
   </div>

</div>
</template>

<script>
export default {
   props: ['contatto','evento','abstract']
}
</script>
